/**
 * Schémas Zod — Messagerie interne (v1.1)
 *
 * Fil de messages textuel par candidature (JobApplication).
 * Participants : étudiant ↔ entreprise.
 * Rôles autorisés à ENVOYER : student, company.
 * Rôles autorisés à LIRE : student, company, responsable, super_admin.
 */
import { z } from 'zod';
import { uuidSchema } from './common.js';
// ─── Envoi d'un message ──────────────────────────────────────────────────────
export const sendMessageSchema = z.object({
    body: z
        .string()
        .min(1, 'Le message ne peut pas être vide.')
        .max(2000, 'Message trop long (2 000 caractères max).'),
});
// ─── Format d'un message retourné par l'API ──────────────────────────────────
export const messageSchema = z.object({
    id: uuidSchema,
    jobApplicationId: uuidSchema,
    senderUserId: uuidSchema,
    senderRole: z.enum(['student', 'company', 'responsable', 'super_admin']),
    // null = message soft-deleté (RGPD) — remplacé par "[message supprimé]" dans l'UI
    body: z.string().nullable(),
    deletedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    // Prénom/nom de l'auteur (résolu par l'API, pas stocké dans la table)
    senderName: z.string().nullable(),
});
// ─── Liste de messages ────────────────────────────────────────────────────────
export const messageListSchema = z.object({
    data: z.object({
        messages: z.array(messageSchema),
        unread: z.number().int().min(0),
        hasMore: z.boolean(),
    }),
});
//# sourceMappingURL=message.js.map